import { UploadFileItem } from '.'
export interface PreviewModalOption {
  fileUrl: string
  open: boolean
}
interface State {
  uploadFileList: UploadFileItem[]
  previewModalOption: PreviewModalOption
}
type ActionType =
  | 'setUploadFileListAction'
  | 'setPreviewModalOptionAction'
  | 'resetStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  uploadFileList: [],
  previewModalOption: {
    fileUrl: '',
    open: false,
  },
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setUploadFileListAction':
      newstate.uploadFileList = action.payload
      return newstate
    case 'setPreviewModalOptionAction':
      newstate.previewModalOption = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      return newstate
  }
}
/**
 * 当前下载队列
 * @param val
 * @returns
 */
export const setUploadFileListAction = (val: UploadFileItem[]): Action => ({
  type: 'setUploadFileListAction',
  payload: val,
})

export const setPreviewModalOptionAction = (
  val: PreviewModalOption,
): Action => ({
  type: 'setPreviewModalOptionAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
import { UploadFileItem } from '.'
export interface PreviewModalOption {
  fileUrl: string
  open: boolean
}
interface State {
  uploadFileList: UploadFileItem[]
  previewModalOption: PreviewModalOption
}
type ActionType =
  | 'setUploadFileListAction'
  | 'setPreviewModalOptionAction'
  | 'resetStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  uploadFileList: [],
  previewModalOption: {
    fileUrl: '',
    open: false,
  },
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setUploadFileListAction':
      newstate.uploadFileList = action.payload
      return newstate
    case 'setPreviewModalOptionAction':
      newstate.previewModalOption = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      return newstate
  }
}
/**
 * 当前下载队列
 * @param val
 * @returns
 */
export const setUploadFileListAction = (val: UploadFileItem[]): Action => ({
  type: 'setUploadFileListAction',
  payload: val,
})

export const setPreviewModalOptionAction = (
  val: PreviewModalOption,
): Action => ({
  type: 'setPreviewModalOptionAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
